<template>

    <v-app-bar
            color="orange accent-4"
            dark
    >

        <v-toolbar-title>XI CARRERA POPULAR 10K DEL ROSCÓN</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn
                style="margin-right: 10px;"
                color="white"
                outlined
                to="/panel"
        >
            Inicio
            <v-icon right dark>mdi-home</v-icon>
        </v-btn>

        <v-btn
                style="margin-right: 10px;"
                color="white"
                outlined
                to="/panel/invitar"
        >
            Invitado
            <v-icon right dark>mdi-pencil</v-icon>
        </v-btn>

        <v-menu offset-y>
            <template v-slot:activator="{ on }">
                <v-btn
                        color="white"
                        outlined
                        dark
                        v-on="on"
                >
                    Listados
                </v-btn>
            </template>
            <v-list>
                <v-list-item :href="`${url}/inscripcion/csv/1`">
                    <v-list-item-title>Roscón 10K</v-list-item-title>
                </v-list-item>
                <v-list-item :href="`${url}/inscripcion/csv/2`">
                    <v-list-item-title>Roscón 7K</v-list-item-title>
                </v-list-item>
                <v-list-item :href="`${url}/inscripcion/csv/3`">
                    <v-list-item-title>Roscón infantil</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script>
    import {cookiesHelper} from "../../_helpers";
    import { config } from "../../config";

    export default {
        name: 'HeaderPanel',
        props: ['titulo', 'subtitulo'],
        data() {
            return {
                token: '',
                url: config.api_url
            }
        },
        created() {
            this.token = cookiesHelper.getCookie('token')
        }

    }
</script>

<style lang="scss">
    @import './../../_static/base';

</style>